import { render, staticRenderFns } from "./huodong.vue?vue&type=template&id=98417ad8&scoped=true&"
import script from "./huodong.vue?vue&type=script&lang=js&"
export * from "./huodong.vue?vue&type=script&lang=js&"
import style0 from "./huodong.vue?vue&type=style&index=0&id=98417ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98417ad8",
  null
  
)

export default component.exports